// React Query 5 wrapper for the inferno-result endpoint.
//
// Cached for 5 minutes — engine results are immutable per (run, engine);
// the only invalidation is a fresh model run, which mounts a new run_id
// and changes the queryKey.

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../auth/AuthProvider";
import { getInfernoResult, InfernoEngineResult } from "../api/inferno";

export function useInfernoResult(projectId: string, runId: string) {
  const { token } = useAuth();

  return useQuery<InfernoEngineResult[], Error>({
    queryKey: ["infernoResult", projectId, runId],
    queryFn: async () => {
      if (!token) throw new Error("No auth token");
      return getInfernoResult(projectId, runId, token);
    },
    staleTime: 1000 * 60 * 5,
    enabled: !!(projectId && runId && token),
  });
}
